import { SessionHandler } from "./SessionHandler.js";
import { IrrigationSetJSON } from "./APITypes.js";

export class IrrigationSetAPI {
    static async addOne(
        name: string,
        connectedZones: string[],
        defaultZoneWateringPercentages: Record<string, number>,
        defaultZoneIrrigationOffsets: Record<string, number>,
        defaultIrrigationDuration: number,
        options: Partial<IrrigationSetJSON> | undefined = undefined,
    ): Promise<Record<string, unknown>> {
        const url = "irrigationSet";
        const body = {
            name,
            zones: connectedZones,
            defaultZoneWateringPercentages: defaultZoneWateringPercentages,
            defaultZoneIrrigationOffsets: defaultZoneIrrigationOffsets,
            defaultIrrigationDuration: defaultIrrigationDuration,
            ...(options || {}),
        };
        const response = await SessionHandler.doFetch(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "POST",
            redirect: "follow",
            body: JSON.stringify(body),
        });
        if (response.ok) {
            return await response.json();
        } else {
            const json = await response.json();
            throw new Error({ ...json });
        }
    }
    static async editOne(id: string, editArgs: Partial<IrrigationSetJSON>): Promise<Record<string, unknown>> {
        const url = "irrigationSet/" + id;

        const body = {
            ...editArgs,
        };
        const response = await SessionHandler.doFetch(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "PATCH",
            redirect: "follow",
            body: JSON.stringify(body),
        });
        if (response.ok) {
            return await response.json();
        } else {
            const json = await response.json();
            throw new Error({ ...json });
        }
    }

    static async deleteOne(id: string) {
        const url = "irrigationSet/" + id;

        const response = await SessionHandler.doFetch(url, {
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            method: "DELETE",
            redirect: "follow",
        });
        if (!response.ok) {
            const json = await response.json();
            throw new Error(json.message ?? "Unknown error");
        }
    }
}
